module.exports = __webpack_public_path__ + "static/img/texun222.b70bb17.png";